import React from 'react'
import TruckIcon from '@material-ui/icons/LocalShippingRounded'
import ToolTip from '../../UI/ToolTip'
import { TwoLineItem, LeftSideColor } from '../../UI/TableItem'
import moment from 'moment'
import { Dispatch, DriverDispatch } from '../Types/types'
import { Dropdown, DropdownItem, DropdownMenuPosition } from '@duik/it'
import MoreIcon from '@material-ui/icons/MoreHoriz'
import cls from '../../styles/Header.scss'
import NotesIcon from '@material-ui/icons/DescriptionRounded'

export type Props = {
  dispatch: Dispatch
  history: {
    push: (path: string) => void
  }
  index: number
  viewDispatchModalToggle: (_id: string) => void
  handleCancelDispatchClick: (_id: string) => void
  handleNotesClick: (_id: string) => void
  driverDispatchItems: DriverDispatch[]
}

const DispatchItem = ({
  dispatch,
  history,
  index,
  viewDispatchModalToggle,
  driverDispatchItems,
  handleCancelDispatchClick,
  handleNotesClick
}: Props) => {
  const color = LeftSideColor(index)
  const acceptedDispatches = driverDispatchItems.filter(item => item.status === 'accepted').length
  const declinedDispatches = driverDispatchItems.filter(item => item.status === 'declined').length
  const isCancelledDispatch = dispatch.status === 'cancelled'

  return (
    <tr
      style={{ borderLeft: `5px solid ${color.color}` }}
      className="tableRowHover"
      key={dispatch._id}
    >
      <TwoLineItem
        text={moment(dispatch.startDateTime).format('MMM DD, YYYY')}
        // subText={
        //   dispatch.startTimes
        //     ? `${moment(dispatch.startTimes[0]).format('HH:mm')} - ${moment(
        //         dispatch.startTimes[dispatch.startTimes.length - 1]
        //       ).format('HH:mm')}`
        //     : ''
        // }
        subText=""
        width="10"
        onClick={() => viewDispatchModalToggle(dispatch._id)}
      />
      <TwoLineItem
        text={dispatch.project.projectName}
        subText={
          dispatch.haulId
            ? `${dispatch.haulId}${dispatch.backHaulId ? ` - ${dispatch.backHaulId}` : ''}`
            : ''
        }
        width="15"
        onClick={() => viewDispatchModalToggle(dispatch._id)}
      />
      <TwoLineItem
        text={dispatch.pickUpSite.siteName}
        subText={dispatch.backHaulPickUpSite ? dispatch.backHaulPickUpSite.siteName : ''}
        width="15"
        onClick={() => viewDispatchModalToggle(dispatch._id)}
      />
      <TwoLineItem
        text={dispatch.dropOffSite.siteName}
        subText={dispatch.backHaulDropOffSite ? dispatch.backHaulDropOffSite.siteName : ''}
        width="15"
        onClick={() => viewDispatchModalToggle(dispatch._id)}
      />
      <TwoLineItem
        text={
          isCancelledDispatch
            ? 'Cancelled'
            : `${acceptedDispatches} of ${driverDispatchItems.length} accepted`
        }
        subText={
          isCancelledDispatch
            ? `${moment(dispatch.cancelledDt).format('MM/DD')} by ${dispatch.updatedBy}`
            : declinedDispatches > 0
            ? 'Some requests were declined'
            : ''
        }
        width="15"
        onClick={() => viewDispatchModalToggle(dispatch._id)}
      />

      <td style={{ textAlign: 'right', width: '10%' }}>
        {isCancelledDispatch ? (
          <>
            <ToolTip title="Notes">
              <NotesIcon className="actionsIcon" onClick={() => handleNotesClick(dispatch._id)} />
            </ToolTip>
            <MoreIcon className="actionsIcon" />
          </>
        ) : (
          <>
            <ToolTip title="Trucks">
              <TruckIcon
                className="actionsIcon"
                onClick={() => history.push(`/app/dispatches/${dispatch._id}`)}
              />
            </ToolTip>
            <Dropdown
              className={cls.dropdownFilter}
              ButtonComponent={(props: any) => (
                <MoreIcon className="actionsIcon" onClick={props.handleToggle} />
              )}
              menuPosition={DropdownMenuPosition['bottom-left']}
              closeOnOptionClick
            >
              <DropdownItem onClick={undefined}>Request Trucks</DropdownItem>
              <DropdownItem onClick={undefined}>View Requested Trucks</DropdownItem>
              <DropdownItem onClick={() => handleCancelDispatchClick(dispatch._id)}>
                Cancel Dispatch
              </DropdownItem>
            </Dropdown>
          </>
        )}
      </td>
    </tr>
  )
}

export default DispatchItem
